import { Injectable } from "@angular/core";
import { Observable, of, Subject, Subscription } from "rxjs";
import { CatalogPaginationRequest } from "../../shared/models/CatalogPagination/CatalogPaginationRequest";
import { EstatusJSON } from "../../shared/models/EstatusJSON";
import { FilterRequest } from "../../shared/models/Filter/FilterRequest";
import { DownloadsCenterAPIService } from "../../shared/services/API/DownloadsCenterAPI.service";

@Injectable({
  providedIn: "root",
})
export class DownloadsCenterService {
  
  public isLoading$: Subject<boolean> = new Subject<boolean>();
  constructor(private roleService: DownloadsCenterAPIService) {
  }

  setLoading(resp) {
    this.isLoading$.next(resp);
  }

  getLoading() {
    return this.isLoading$.asObservable();
  }

  //paginacion
  getFilterValues(request : FilterRequest[]) {
    return this.roleService.getFilterValues(request);
  }

  getPage(pageRequest: CatalogPaginationRequest) {
    return this.roleService.getPage(pageRequest);
  }

  getCount(pageRequest: CatalogPaginationRequest) {
    return this.roleService.getCount(pageRequest);
  }

}
